import React, { useState, useEffect } from "react";
import AirTrackingPanel from "./AirTrackingPanel";
import OceanTrackingPanel from "./OceanTrackingPanel";
import "./AddTrackingDrawer.css";
import OceanBulkUpload from "./OceanBulkUpload";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BulkUploadAWB from "./BulkUploadAWB";
import ServiceTypeToggle from "../shared/ServiceTypeToggle";

export default function AddTrackingDrawerOpen({
    open,
    onClose,
    setShowAirBulk,
    showAirBulk
}: any) {
    const [activeTab, setActiveTab] = useState<"air" | "ocean">("air");

    useEffect(() => {
        document.body.style.overflow = open ? "hidden" : "auto";
    }, [open]);

    if (!open) return null;


    return (

        <div className="drawer-overlay" onClick={onClose}>
            <div className="atd-drawer" onClick={e => e.stopPropagation()}>
                {/* Toggle */}
                <div className="atd-header">
                    <div className="atd-header-row">
                        <div className="arrowBackDrawerAi">
                            {showAirBulk && <div className="arrowBackDrawer">
                                <ArrowBackIcon style={{ cursor: "pointer" }} onClick={() => setShowAirBulk(false)} />
                            </div>}
                            <span className="atd-title">Add Tracking</span>
                        </div>
                        <button className="atd-close-btn" onClick={onClose}>✕</button>
                    </div>
                </div>

                {/* Toggle */}
                <div className="atd-body-outer">
                    <ServiceTypeToggle onTypeChange={setActiveTab} activeTab={activeTab} 
                    width="100%"
                    />

                    <div className="atd-body">
                        {activeTab === "air" && (!showAirBulk ?
                            <AirTrackingPanel setShowAirBulk={setShowAirBulk} activeTab={activeTab} drawerClose={onClose} /> :
                            <div className="boxSecond">

                                <BulkUploadAWB setShowAirBulk={setShowAirBulk} />

                            </div>
                        )}


                      
                        {activeTab === "ocean" && (
                            !showAirBulk ?
                                <OceanTrackingPanel setShowAirBulk={setShowAirBulk} activeTab={activeTab} drawerClose={onClose} /> :
                                <div className="boxSecond">
                                    <OceanBulkUpload />

                                </div>
                        )}
                    </div>
                </div>
            </div>
        </div>

    );
}